import React from 'react'

interface WizardNavigationProps {
  currentStep: number
  totalSteps: number
  onBack: () => void
  onNext: () => void
  isSubmitting: boolean
  dirty: boolean
  isValid: boolean
  agreeToPolicy: boolean
  missingFields?: string[]
}

/**
 * Reusable wizard navigation component for multi-step forms
 * Renders Back/Next/Submit buttons with appropriate styling and logic
 */
const WizardNavigation: React.FC<WizardNavigationProps> = ({
  currentStep,
  totalSteps,
  onBack,
  onNext,
  isSubmitting,
  dirty,
  isValid,
  agreeToPolicy,
  missingFields = []
}) => {
  const isSubmitDisabled = isSubmitting || !dirty || !isValid || !agreeToPolicy
  const isLastStep = currentStep >= totalSteps

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
      <div className="wizard-navigation" style={{ marginTop: '2rem', display: 'flex', gap: '1rem', justifyContent: 'space-between' }}>
        {currentStep > 1 && (
          <button
            type="button"
            onClick={onBack}
            style={{ background: 'transparent', color: '#232043', border: '2px solid #232043' }}
          >
            <span style={{ fontWeight: 700, letterSpacing: 1.2 }}>Back</span>
          </button>
        )}
        {!isLastStep ? (
          <button
            type="button"
            onClick={onNext}
            style={{
              background: '#232043', color: 'yellow',
              marginLeft: currentStep === 1 ? 'auto' : '0',
            }}
          >
            <span style={{ fontWeight: 700, letterSpacing: 1.2 }}>Next</span>
          </button>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginLeft: 'auto' }}>
            <button
              type="submit"
              disabled={isSubmitDisabled}
              style={{ background: '#232043', color: 'yellow' }}
            >
              <span style={{ fontWeight: 700, letterSpacing: 1.2 }}>
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </span>
            </button>
            {isSubmitDisabled && !isSubmitting && missingFields.length > 0 && (
              <div style={{ color: '#e74c3c', fontSize: '0.85rem', textAlign: 'right' }}>
                {missingFields.map((msg, i) => (
                  <div key={i}>{msg}</div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default WizardNavigation
